export default __webpack_public_path__ + "static/media/website_spot_FINAL.457cb420.png";